import styled from "@emotion/styled";
import { useEffect, useMemo, useState } from "react";

import { ReactComponent as MarginTradingIcon } from "../../../assets/margin-trading.svg";
import { useLanguageContext } from "../../../contexts/language/language";
import { useMarginContext } from "../../../contexts/margin";
import type { CollapseControlProps } from "../../../hooks/home/useCollapseControl";
import type { MarginAccount } from "../../../types/margin";
import { ChevronCollapse } from "../ChevronCollapse/ChevronCollapse";
import { MarginBalances } from "./MarginBalances";
import { MarginOpenOrders } from "./MarginOpenOrders";
import { MarginOverview } from "./MarginOverview";
import { MarginPerpetualPositions } from "./MarginPerpetualPositions";
import { MarginUnsettledBalances } from "./MarginUnsettledBalances";

export const MarginTrading: React.FC<CollapseControlProps> = ({ activePanels, getPanelKey, onPanelClick }) => {
  const { marginAccounts, /*mangoHelpers refreshContext,*/ setMarginBalance } = useMarginContext();
  //const { mangoAccounts, spotMarkets, mangoClient, mangoGroup } = mangoHelpers;
  //const wallet = useConnectedWallet();

  const [busy, _setBusy] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<MarginAccount | undefined>(undefined);

  const selectedAccounts = useMemo(
    () => (selectedAccount ? [selectedAccount] : marginAccounts),
    [marginAccounts, selectedAccount],
  );
  const totalEquity = useMemo(() => selectedAccounts.reduce((a, b) => (a += b.equity), 0), [selectedAccounts]);
  const openOrders = useMemo(() => selectedAccounts.flatMap((account) => account.orders), [selectedAccounts]);
  const perps = useMemo(() => selectedAccounts.flatMap((account) => account.perpetuals), [selectedAccounts]);
  const unsettledBalances = useMemo(
    () => selectedAccounts.flatMap((account) => account.balances.filter((balance) => balance.unsettled > 0)),
    [selectedAccounts],
  );

  const {
    currentLanguageData: {
      pages: {
        dashboard: {
          modules: { marginTrading: marginTradingText },
        },
      },
    },
  } = useLanguageContext();

  useEffect(() => {
    setMarginBalance(totalEquity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalEquity, selectedAccounts]);

  const handleSettleAll = async () => {
    /*if (wallet && wallet.publicKey && mangoGroup) {
      setBusy(true);
      for (const mangoAccount of mangoAccounts) {
        const foundAccount = selectedAccounts.find((a) => a.pubkey.equals(mangoAccount.publicKey));
        if (foundAccount && foundAccount.balances.find((b) => b.unsettled > 0)) {
          try {
            await mangoClient.settleAll(
              mangoGroup,
              mangoAccount,
              spotMarkets as unknown as Market[],
              wallet as WalletAdapter,
            );
            notify({ message: `Successfully settled funds for account`, type: "success" });
          } catch (e) {
            handlePreSendTxnError(e as Error, "Error settling funds");
          }
        }
      }
      refreshContext();
      setBusy(false);
    }*/
  };
  return marginAccounts.length > 0 && totalEquity > 0 ? (
    <MarginContainer>
      <ChevronCollapse
        title={marginTradingText.title}
        value={totalEquity}
        TitleIcon={MarginTradingIcon}
        activePanels={activePanels}
        panelKey={getPanelKey("MarginTrading")}
        onChange={onPanelClick}
      >
        <>
          <MarginOverview
            marginAccounts={marginAccounts}
            selectedAccount={selectedAccount}
            onAccountChange={setSelectedAccount}
          />
          {perps.length > 0 && <MarginPerpetualPositions positions={perps} />}
          {openOrders.length > 0 && <MarginOpenOrders orders={openOrders} />}
          <MarginBalances selectedAccounts={selectedAccounts} />
          {unsettledBalances.length > 0 && (
            <MarginUnsettledBalances
              unsettledBalances={unsettledBalances}
              settleDisabled={busy}
              onSettleAll={handleSettleAll}
            />
          )}
        </>
      </ChevronCollapse>
    </MarginContainer>
  ) : null;
};

const MarginContainer = styled.div`
  margin-top: 20px;

  .ant-collapse {
    .ant-collapse-item {
      .ant-collapse-content {
        overflow-x: hidden;
      }
    }
  }
`;
